var React = require('react');
var FormElement = require('./FormElement');

class Calculator extends React.Component {
    constructor(props) {
        super(props);

        this.config = props.config;

        this.fields = {};

        this.state = {
            currency: '$'
        };

        this.nextState = {};

        // We will use this to reset the form to default later
        this.defaultState = {};

        // All the events will be stored here.
        this.events = {};

        // Formulas for all the field.
        this.formulas = {};

        this.init();

        this.handleChange = this.handleChange.bind(this);

        this.resetForm = this.resetForm.bind(this);
    }

    init() {
        let key;

        // Walk through the config and setup fields, state, events, formulas
        for (key in this.config) {

            // Setup data format

            if ('number' === typeof this.config[key].default && 'undefined' === typeof this.config[key].format) {
                this.config[key].format = 'number';
            }

            this.fields[this.config[key].name] = this.config[key];

            // Setup state of field values
            this.state['values_' + this.config[key].name] = this.config[key].default;

            // Setup state of field show/hide
            this.state['hidden_' + this.config[key].name] = this.config[key].hidden;

            // Setup state of field type
            this.state['type_' + this.config[key].name] = this.config[key].type;

            // Setup events
            if ('function' === typeof this.config[key].onchange) {
                this.events[this.config[key].name] = this.config[key].onchange;
            }

            // Setup formula
            if ('function' === typeof this.config[key].formula) {
                this.formulas[this.config[key].name] = this.config[key].formula;
            }
        }

        this.defaultState = this.state;
    }

    updateValues(newValue) {
        let key;
        let obj = {};
        for (key in newValue) {
            obj['values_' + key] = newValue[key];
            this.setState(obj);
        }
    }

    updateHidden(newValue) {
        let key;
        let obj = {};
        for (key in newValue) {
            obj['hidden_' + key] = newValue[key];
            this.setState(obj);
        }
    }

    updateType(newValue) {
        let key;
        let obj = {};
        for (key in newValue) {
            obj['type_' + key] = newValue[key];
            this.setState(obj);
        }
    }

    updateCurrency(newValue) {
        this.setState(newValue);
    }

    /**
     * Show up an element
     */
    toggleHiddenState(fieldName, value) {
        //console.log(fieldName);
        let obj = {};
        obj[fieldName] = value;

        this.updateHidden(obj);
    }

    setTypeState(fieldName, value) {
        let obj = {};
        obj[fieldName] = value;

        this.updateType(obj);
    }

    handleChange(event) {
        let key;
        for (key in event) {
            //console.log(key);
            if ('function' === typeof this.events[key]) { // Setup events for all the configured config
                this.events[key].bind(this)(event);
            } else if ('currency' === key) {
                this.setState({currency: event[key]});
            } else {
                this.updateValues(event);
            }
        }
    }

    resetForm(event) {
        this.setState(this.defaultState);
    }

    componentWillUpdate(nextProps, nextState) {
        this.calculate(nextState);
    }

    calculate(nextState) {
        let key;

        // Only calculate once
        if (JSON.stringify(nextState) === JSON.stringify(this.state)) return;

        this.nextState = nextState;

        // Walking through states to get field ID and implement result using its formula
        for (key in this.fields) {
            if ('function' === typeof this.formulas[key]) {
                let obj = {};
                obj[key] = this.formulas[key].bind(this)();
                this.updateValues(obj);
            }
        }
    }

    prepareProp(field) {
        return 'undefined' !== typeof(field) ? field : null;
    }

    render() {
        let fields = [];
        let key;
        for (key in this.fields) {
            let field = this.fields[key];
            let source = this.prepareProp(field.source);
            let callback = this.prepareProp(field.callback);

            let hidden = 'undefined' !== typeof(this.state['hidden_' + field.name]) ? this.state['hidden_' + field.name] : false;
            let currencySymbol = ('undefined' !== typeof(this.state.currency) && field.name === 'cs') ? this.state.currency : false;
            let id = field.name === 'cs' ? this.props.id:false;

            fields.push((
                <FormElement key={field.name} type={this.state['type_' + field.name]} name={field.name}
                             label={field.label} format={field.format}
                             hidden={hidden}
                             value={this.state['values_' + field.name]}
                             source={source}
                             callback={callback}
                             currency={this.state['currency']}
                             onChange={this.handleChange}
                             id={id}
                             currencySymbol={currencySymbol}
                />
            ));
        }

        return (
            <div>
                <form id={this.props.id}>
                    {fields}
                    <div className="form-group row">
                        <label className="col-sm-4 col-form-label text-right">&nbsp;</label>
                        <div className="col-sm-6 text-left">
                            <button type="button" className="btn btn-primary" onClick={this.resetForm}>Xóa tất cả
                            </button>
                        </div>
                    </div>
                </form>
            </div>
        );
    }
}

module.exports = Calculator;


// WEBPACK FOOTER //
// ./src/Calculator.js